<template>
  <div>
    <section class="info-type">
      <label class="service-label">房间信息</label>
      <Form :label-width="110">
        <section class="display-flex">
          <FormItem label="房屋结构：">
            <Select class="ivu-select-width" transfer>
              <Option :value="1">标准平层</Option>
              <Option :value="2">复式结构</Option>
              <Option :value="3">别墅</Option>
              <Option :value="4">四合院</Option>
            </Select>
          </FormItem>
          <FormItem label="装修风格：">
            <Select class="ivu-select-width" transfer>
              <Option :value="1">地中海风格</Option>
              <Option :value="2">工业风格</Option>
            </Select>
          </FormItem>
        </section>
        <FormItem label="房型：">
          <Select class="ivu-select-width">
            <Option :value="1">大床房</Option>
            <Option :value="2">双床房</Option>
          </Select>
          <section class="display-flex">
            <Input type="text" class="input-inline-width">
              <span slot="append">厅</span>
            </Input>
            <Input type="text" class="input-inline-width">
              <span slot="append">卧室</span>
            </Input>
            <Input type="text" class="input-inline-width">
              <span slot="append">卫</span>
            </Input>
            <Input type="text" class="input-inline-width">
              <span slot="append">书房</span>
            </Input>
            <Input type="text" class="input-inline-width">
              <span slot="append">厨</span>
            </Input>
            <Input type="text" class="input-inline-width">
              <span slot="append">阳台</span>
            </Input>
            <Input type="text" class="input-inline-width">
              <span slot="append">院子</span>
            </Input>
          </section>
          <span class="tips">卧室最小值为1，其余最小值为0，必填</span>
        </FormItem>
        <section class="display-flex">
          <FormItem label="床数：">
            <InputNumber :min="1"></InputNumber>
          </FormItem>
          <FormItem label="床描述：">
            <Input type="text" class="desc-input-width"></Input>
          </FormItem>
        </section>
        <FormItem label="可住人数：">
          <InputNumber :min="1"></InputNumber>
        </FormItem>
        <FormItem label="房间类型：">
          <Select class="ivu-select-width" transfer>
            <Option :value="1">金级</Option>
            <Option :value="2">银级</Option>
            <Option :value="3">铜级</Option>
          </Select>
        </FormItem>
      </Form>
    </section>
    <section class="info-type">
      <label class="service-label">设施服务</label>
      <Form :label-width="110">
        <FormItem label="品牌优选：">
          <CheckboxGroup>
            <Checkbox label="Eat"></Checkbox>
            <Checkbox label="Sleep"></Checkbox>
            <Checkbox label="Run"></Checkbox>
            <Checkbox label="Movie"></Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="个性标签：">
          <CheckboxGroup>
            <Checkbox label="Eat"></Checkbox>
            <Checkbox label="Sleep"></Checkbox>
            <Checkbox label="Run"></Checkbox>
            <Checkbox label="Movie"></Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="房内设施：">
          <CheckboxGroup>
            <Checkbox label="Eat"></Checkbox>
            <Checkbox label="Sleep"></Checkbox>
            <Checkbox label="Run"></Checkbox>
            <Checkbox label="Movie"></Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="其他服务：">
          <CheckboxGroup>
            <Checkbox label="Eat"></Checkbox>
            <Checkbox label="Sleep"></Checkbox>
            <Checkbox label="Run"></Checkbox>
            <Checkbox label="Movie"></Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>
    </section>
    <section class="info-type">
      <label class="service-label">物品信息</label>
      <Form :label-width="110">
        <FormItem label="床上用品：">
          <CheckboxGroup>
            <Checkbox label="Eat"></Checkbox>
            <Checkbox label="Sleep"></Checkbox>
            <Checkbox label="Run"></Checkbox>
            <Checkbox label="Movie"></Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="洗护用品：">
          <CheckboxGroup>
            <Checkbox label="Eat"></Checkbox>
            <Checkbox label="Sleep"></Checkbox>
            <Checkbox label="Run"></Checkbox>
            <Checkbox label="Movie"></Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="家具家电：">
          <CheckboxGroup>
            <Checkbox label="Eat"></Checkbox>
            <Checkbox label="Sleep"></Checkbox>
            <Checkbox label="Run"></Checkbox>
            <Checkbox label="Movie"></Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="其他客房物品：">
          <CheckboxGroup>
            <Checkbox label="Eat"></Checkbox>
            <Checkbox label="Sleep"></Checkbox>
            <Checkbox label="Run"></Checkbox>
            <Checkbox label="Movie"></Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="布草：">
          <CheckboxGroup>
            <Checkbox label="Eat"></Checkbox>
            <Checkbox label="Sleep"></Checkbox>
            <Checkbox label="Run"></Checkbox>
            <Checkbox label="Movie"></Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="易耗品：">
          <CheckboxGroup>
            <Checkbox label="Eat"></Checkbox>
            <Checkbox label="Sleep"></Checkbox>
            <Checkbox label="Run"></Checkbox>
            <Checkbox label="Movie"></Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>
    </section>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
.service-label{
  display: block;
  margin-bottom: 20px;
  font-size: 16px;
}
.ivu-select-width{
  width: 220px
}
.display-flex {
  display: flex;
  flex-direction: row;
  .ivu-select {
    width: 220px;
  }
  button {
    margin-left: 20px;
  }
  .ivu-input-wrapper.input-inline-width{
    margin: 10px 20px 10px 0;
    width: 100px;
  }
}
.info-type{
  margin-bottom: 40px;
}
.tips{
  color: #ed3f14;
}
.desc-input-width{
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/pages/room/room-detail/service.vue